import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string) => (
    <>
        <path
            d="M10.5833 16.4998C10.5833 17.0061 10.9937 17.4165 11.5 17.4165C12.0063 17.4165 12.4167 17.0061 12.4167 16.4998C12.4167 15.9936 12.0063 15.5832 11.5 15.5832C10.9937 15.5832 10.5833 15.9936 10.5833 16.4998Z"
            fill={color}/>
        <path
            d="M16.863 10.582C16.1268 9.79251 15.2254 9.1753 14.2232 8.77441M19.5446 8.0814C18.4403 6.89718 17.0881 5.97136 15.5847 5.37004C14.0813 4.76871 12.4638 4.50649 10.8474 4.60252M8.14755 13.3744C8.70941 12.7719 9.42328 12.332 10.2141 12.1009C11.0048 11.8698 11.8433 11.8556 12.6412 12.0607M6.13697 10.5817C7.0063 9.64945 8.10363 8.9599 9.32072 8.58105M3.455 8.0812C4.27805 7.1986 5.24072 6.45744 6.30444 5.88745M4.54623 3.6665L17.5099 16.6301M11.5 17.4165C10.9937 17.4165 10.5833 17.0061 10.5833 16.4998C10.5833 15.9936 10.9937 15.5832 11.5 15.5832C12.0063 15.5832 12.4167 15.9936 12.4167 16.4998C12.4167 17.0061 12.0063 17.4165 11.5 17.4165Z"
            stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>

    </>
)

export const WifiOff: React.FC<IconProps> = ({color, size}) => <IconWrapper {...{size, color, renderIcon}} />
